import { useCallback } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { DataTable, type Column } from '../components/DataTable';
import { hierarchy, type Agency, type Client, type ListParams } from '../lib/api';

const agencyColumns: Column<Agency>[] = [
  { key: 'name', label: 'Agency', sortField: 'company_name', render: (a) => <strong>{a.companyName}</strong> },
  { key: 'email', label: 'Email', sortField: 'email', render: (a) => a.email },
  { key: 'city', label: 'City', sortField: 'city', render: (a) => a.city },
  { key: 'state', label: 'State', sortField: 'state', width: '5rem', render: (a) => a.state },
  { key: 'active', label: 'Status', width: '6rem',
    render: (a) => <span className={a.isActive ? 'pill ok' : 'pill off'}>{a.isActive ? 'active' : 'inactive'}</span> },
];

export function AgenciesScreen() {
  const navigate = useNavigate();
  const load = useCallback((p: ListParams) => hierarchy.agencies(p), []);
  return (
    <DataTable
      title="Agencies"
      columns={agencyColumns}
      load={load}
      initialSort="company_name"
      initialDirection="asc"
      searchPlaceholder="Search agencies…"
      onRowClick={(a) => navigate(`/agencies/${a.id}`)}
    />
  );
}

const clientColumns: Column<Client>[] = [
  { key: 'name', label: 'Client', sortField: 'company_name', render: (c) => <strong>{c.companyName}</strong> },
  { key: 'email', label: 'Email', sortField: 'email', render: (c) => c.email },
  { key: 'city', label: 'City', sortField: 'city', render: (c) => c.city },
  { key: 'state', label: 'State', width: '5rem', render: (c) => c.state },
];

/** Agency detail is its client list — the requirement, and the natural next step down. */
export function AgencyDetailScreen() {
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const load = useCallback((p: ListParams) => hierarchy.agencyClients(id, p), [id]);
  return (
    <>
      <nav className="crumbs"><Link to="/agencies">Agencies</Link> <span>/</span> <span>Clients</span></nav>
      <DataTable
        title="Clients"
        columns={clientColumns}
        load={load}
        initialSort="company_name"
        initialDirection="asc"
        searchPlaceholder="Search clients…"
        emptyMessage="This agency has no clients."
        onRowClick={(c) => navigate(`/clients/${c.id}`)}
      />
    </>
  );
}
